module.exports = __webpack_public_path__ + "img/mapE.84408b43.jpg";